import EmailIcon from '@listening/assets/icons/email.svg?react';
import PasswordIcon from '@listening/assets/icons/password.svg?react';
import {
  FormControl,
  FormField,
  FormItem,
  FormMessage,
} from '@listening/frontend/components/radix/form';
import { Input } from '@listening/frontend/components/radix/input';
import { PasswordInput } from './password-input';
import type { ComponentProps } from 'react';
import * as m from '@/paraglide/messages';
import type { AuthForm } from '@/hooks/login-logout.hook';

export const authInputClassName =
  'rounded-full border-none bg-gray-100 placeholder:text-secondary-foreground dark:bg-gray-900/10 dark:autofill:shadow-[inset_0_0_0px_1000px_#8997ba] dark:[&:-webkit-autofill]:[-webkit-text-fill-color:white]';

const AuthFormInput = ({ ref, ...props }: ComponentProps<typeof Input>) => (
  <Input
    className={authInputClassName}
    ref={ref}
    wrapperClassName='w-full'
    {...props}
  />
);

export function AuthFormEmailInput(props: { form: AuthForm }) {
  return (
    <FormField
      control={props.form.control}
      name='email'
      render={({ field }) => (
        <FormItem className='relative'>
          <FormControl>
            <AuthFormInput
              autoComplete='email'
              icon={<EmailIcon className='text-secondary-foreground' />}
              placeholder={m.auth_email_placeholder()}
              {...field}
            />
          </FormControl>
          <FormMessage className='absolute -bottom-5 text-xs' />
        </FormItem>
      )}
    />
  );
}

export function AuthFormPasswordInput(props: { form: AuthForm }) {
  return (
    <FormField
      control={props.form.control}
      name='password'
      render={({ field }) => (
        <FormItem className='relative'>
          <FormControl>
            <PasswordInput
              appearance='auth'
              className={authInputClassName}
              wrapperClassName='w-full'
              autoComplete='current-password'
              icon={<PasswordIcon className='text-secondary-foreground' />}
              iconPosition='left'
              placeholder={m.auth_password_placeholder()}
              {...field}
            />
          </FormControl>
          <FormMessage className='absolute -bottom-5 text-xs text-nowrap' />
        </FormItem>
      )}
    />
  );
}
